import React, { useEffect, useState } from "react";
import useSearchStringRedirect from "../../../router/useSearchStringRedirect";
import { useSelector, useDispatch } from "react-redux";
import * as Admin from "../../../store/ducks/admin.duck";
import * as Auth from "../../../store/ducks/auth.duck";
import { Card, Modal } from "react-bootstrap";
import "../../../../_metronic/_assets/css/app2.css";
import UpdatePassword from "../../../components/UpdatePassword";
import Carousel from "react-bootstrap/Carousel";
import { ToastContainer, Flip } from "react-toastify";
import "../../../../_metronic/_assets/css/app2.css";

export default function DashboardCentralisedService() {
  const dispatch = useDispatch();
  const isRecovery = useSelector((state) => state.auth.recoveryStatus);
  const pathwayDocumentLink = useSelector((state) => state.admin.PathwayDocumentLink);
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);
  const csNews = useSelector((state) => state.admin.CSNews);
  const csProviderSpotlight = useSelector((state) => state.admin.CSProviderSpotlight);

  const IMAGE_BASE = "https://files.ruralhealthconnect.com.au/fileStoreRHC/";
  const PLACEHOLDER_IMAGE = "https://files.ruralhealthconnect.com.au/fileStoreRHC/blank.jpg";

  useSearchStringRedirect();

  useEffect(() => {
    dispatch(Admin.actions.fetchPathwayDocumentLink());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsNews());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsProviderSpotlight());
  }, [dispatch]);

  useEffect(() => {
    if (isRecovery === "Recovery") {
      dispatch(Auth.actions.clearRecovery());
      setShowUpdatePassword(true);
    }
  }, [dispatch, isRecovery]);

  return (
    <div style={{ color: "#004f53" }}>
      <div className="row" style={{ marginBottom: 35 }}>
        <div className="col-12 text-center">
          {/* LOGO + TITLE */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 15,
              marginBottom: 10,
            }}
          >
            <img src={`${process.env.PUBLIC_URL}/media/logos/centralised-services-logo.svg`} alt="Centralised Service Logo" style={{ height: 60 }} />
          </div>

          {/* SUBTITLE */}
          <p
            style={{
              fontSize: "1.6rem",
              fontWeight: 500,
              maxWidth: 1000,
              margin: "0 auto",
            }}
          >
            Psychology and Psychiatry support over telehealth for Medicare Mental Health Centres
          </p>

          {/* SPACING */}
          <div style={{ height: 25 }} />

          {/* HELP TEXT */}
          <p style={{ fontSize: "1.2rem", marginBottom: 8 }}>We are here to help.</p>

          {/* CONTACT */}
          <p style={{ fontSize: "1.25rem", marginBottom: 20 }}>
            Please contact us for assistance via &nbsp;
            <a href="mailto:csadmin@ruralhealthconnect.com.au" style={{ fontWeight: 700 }}>
              csadmin@ruralhealthconnect.com.au
            </a>{" "}
            or <span style={{ fontWeight: 700 }}>1800 841 055</span>
          </p>

          {/* SOFT DIVIDER */}
          <div
            style={{
              width: 120,
              height: 4,
              background: "#2c7be5",
              margin: "0 auto",
              borderRadius: 2,
              opacity: 0.7,
            }}
          />
        </div>
      </div>{" "}
      <div className="row align-items-stretch" style={{ marginTop: 20 }}>
        {/* LEFT SIDE - 2/3 Carousel */}
        <div className="col-md-8 d-flex flex-column">
          {/* LEFT TITLE */}
          <h4 style={{ textAlign: "left", marginBottom: 15 }}>News and Updates</h4>

          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: 10,
              width: "100%",
              height: 387,
              backgroundColor: "#fff",
              overflow: "visible",
            }}
          >
            <Carousel variant="dark" style={{ height: "100%", backgroundColor: "#F2F2F2" }} className="custom-carousel">
              {csNews &&
                Array.isArray(csNews) &&
                csNews.map((itm, idx) => {
                  const hasImage = !!itm.image_url;
                  const imageUrl = hasImage ? `${IMAGE_BASE}${itm.image_url}` : null;

                  return (
                    <Carousel.Item key={idx}>
                      <div
                        className="d-flex align-items-center"
                        style={{
                          height: 330,
                          width: "80%",
                          margin: "0 auto",
                          padding: "10px 0",
                          boxSizing: "border-box",
                        }}
                      >
                        {/* IMAGE ONLY IF EXISTS */}
                        {hasImage && (
                          <div style={{ flex: "0 0 35%", paddingRight: 20 }}>
                            <img
                              src={imageUrl}
                              alt={itm.title}
                              style={{
                                width: "100%",
                                height: 210,
                                objectFit: "cover",
                                borderRadius: 8,
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                        )}
                        {/* TEXT */}
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            paddingLeft: hasImage ? 0 : 10,
                            paddingRight: 10,
                          }}
                        >
                          {itm.title && (
                            <h3
                              style={{
                                margin: "5px 15px 10px",
                                fontWeight: "bold",
                              }}
                            >
                              {itm.title}
                            </h3>
                          )}

                          <p
                            style={{
                              fontSize: "1.2rem",
                              margin: "10px 15px",
                              lineHeight: 1.7,
                              whiteSpace: "pre-line",
                            }}
                          >
                            {itm.copy}
                          </p>

                          {itm.pdf_url && (
                            <a
                              href={itm.pdf_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-block",
                                marginTop: 20,
                                marginLeft: 15,
                                color: "#007bff",
                                textDecoration: "underline",
                                fontWeight: 500,
                              }}
                            >
                              Read More
                            </a>
                          )}
                        </div>{" "}
                      </div>{" "}
                    </Carousel.Item>
                  );
                })}
            </Carousel>
          </div>
        </div>
        {/* RIGHT SIDE - 1/3 YouTube */}
        <div className="col-md-4 d-flex flex-column" style={{ paddingLeft: 20 }}>
          <h4 style={{ textAlign: "left", marginBottom: 15 }}>How to refer</h4>
          <div
            style={{
              width: "100%",
              height: 387,
              border: "1px solid #ddd",
              borderRadius: 10,
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/kG9oc2Qvlm4"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>
        </div>
      </div>
      {/* PROVIDER SPOTLIGHT ROW */}
      <div className="row align-items-stretch" style={{ marginTop: 30 }}>
        {/* LEFT SIDE - 2/3 Provider Spotlight */}
        <div className="col-md-8 d-flex flex-column">
          <h4 style={{ textAlign: "left", marginBottom: 15 }}>Provider Spotlight</h4>

          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: 10,
              padding: 20,
              width: "100%",
              backgroundColor: "#fff",
            }}
          >
            {csProviderSpotlight && (
              <div className="d-flex align-items-start">
                {/* IMAGE */}
                <div
                  style={{
                    flex: "0 0 28%",
                    paddingRight: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={csProviderSpotlight.image_url ? `${IMAGE_BASE}${csProviderSpotlight.image_url}` : PLACEHOLDER_IMAGE}
                    alt={csProviderSpotlight.title}
                    style={{
                      width: "100%",
                      maxWidth: 240,
                      height: 320,
                      objectFit: "cover",
                      borderRadius: 8,
                    }}
                    onError={(e) => {
                      e.target.src = PLACEHOLDER_IMAGE;
                    }}
                  />
                </div>
                {/* TEXT */}
                <div style={{ flex: 1 }}>
                  <h3
                    style={{
                      marginTop: 20,
                      marginBottom: 15,
                      marginLeft: 15,
                      fontWeight: 600,
                    }}
                  >
                    {csProviderSpotlight.title}
                  </h3>

                  <p
                    style={{
                      fontSize: "1.1rem",
                      marginLeft: 15,
                      lineHeight: 1.6,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {csProviderSpotlight.copy}
                  </p>
                  {csProviderSpotlight.pdf_url && (
                    <a
                      href={csProviderSpotlight.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        marginTop: 15,
                        marginLeft: 15,
                        color: "#007bff",
                        textDecoration: "underline",
                      }}
                    >
                      Read More
                    </a>
                  )}
                </div>{" "}
              </div>
            )}
          </div>
        </div>

        {/* RIGHT SIDE - 1/3 Sponsor Logo */}
        <div className="col-md-4 d-flex flex-column" style={{ paddingLeft: 20 }}>
          <h4 style={{ textAlign: "left", marginBottom: 15 }}> </h4>

          <div
            style={{
              // border: "1px solid #ddd",
              borderRadius: 10,
              height: "100%",
              // backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: 20,
              textAlign: "center",
            }}
          >
            <p style={{ marginBottom: 15, fontWeight: 600, fontSize: "1.5rem" }}>Brought to you by</p>

            <img
              src={`${process.env.PUBLIC_URL}/media/logos/logo-3.png`}
              alt="Rural Health Connect Logo"
              style={{
                maxWidth: "80%",
                maxHeight: 120,
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          marginTop: 20,
          marginBottom: 30,
          fontSize: "1.2rem",
        }}
      >
        We value your feedback. Please submit here anytime:{" "}
        <a href="https://www.surveymonkey.com/r/RXYNPQL" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 600 }}>
          https://www.surveymonkey.com/r/RXYNPQL
        </a>
      </div>
      <div
        style={{
          textAlign: "center",
          marginTop: 20,
          marginBottom: 30,
          fontSize: "1.2rem",
        }}
      >
        Login directly at{" "}
        <a href="https://centralisedservice.com.au" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 600 }}>
          https://centralisedservice.com.au/
        </a>
      </div>
      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Modal show={showUpdatePassword} onHide={() => setShowUpdatePassword(false)} dialogClassName="todos-modal-dialog">
        <Modal.Header closeButton className="todos-modal">
          <Modal.Title>You have recently recovered your password, please update your password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="todos-modal">
          <UpdatePassword setShowUpdatePassword={setShowUpdatePassword} />
        </Modal.Body>
      </Modal>
    </div>
  );
}
